import React from 'react'
import {
  Box,
  Button,
  CircularProgress,
  Divider,
  List,
  Typography,
} from '@mui/material'
import { DoneAll as DoneAllIcon } from '@mui/icons-material'
import { Notification } from '@store/api/notificationApi'
import NotificationItem from './NotificationItem'

interface Props {
  notifications: Notification[]
  isLoading?: boolean
  onMarkAsRead: (id: string) => void
  onMarkAllAsRead: () => void
  onDelete: (id: string) => void
}

const NotificationList: React.FC<Props> = ({
  notifications,
  isLoading,
  onMarkAsRead,
  onMarkAllAsRead,
  onDelete,
}) => {
  const unreadCount = notifications.filter((n) => !n.isRead).length

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 3 }}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  if (notifications.length === 0) {
    return (
      <Box sx={{ p: 3, textAlign: 'center' }}>
        <Typography variant="body2" color="text.secondary">
          No notifications yet
        </Typography>
      </Box>
    )
  }

  return (
    <Box>
      {unreadCount > 0 && (
        <>
          <Box sx={{ px: 2, py: 1, display: 'flex', justifyContent: 'flex-end' }}>
            <Button
              size="small"
              startIcon={<DoneAllIcon />}
              onClick={onMarkAllAsRead}
            >
              Mark all as read
            </Button>
          </Box>
          <Divider />
        </>
      )}
      <List disablePadding>
        {notifications.map((notification) => (
          <NotificationItem
            key={notification.id}
            notification={notification}
            onMarkAsRead={onMarkAsRead}
            onDelete={onDelete}
          />
        ))}
      </List>
    </Box>
  )
}

export default NotificationList
